// external libs
import { Box } from '@material-ui/core'

// components
import ChecklistAnswerItem from './ChecklistAnswerItem'

// types
import type { ChecklistAnswer } from '../../../services/um/useChecklist'

export interface ChecklistAnswerListProps {
    topicID: number
    parentID: number
    childrenID?: number | undefined
    checklistAnswerList: ChecklistAnswer[]
    onChange?: () => void
}

function ChecklistAnswerList(props: ChecklistAnswerListProps) {
    const { topicID, parentID, childrenID, checklistAnswerList, onChange } = props

    return (
        <Box display="flex" flexDirection="column" pl={10} style={{ gap: 16 }}>
            {checklistAnswerList?.map((checklistAnswer) => (
                <ChecklistAnswerItem
                    key={checklistAnswer.checklistID}
                    topicID={topicID}
                    parentID={parentID}
                    childrenID={childrenID}
                    checklistAnswer={checklistAnswer}
                    onChange={onChange}
                />
            ))}
        </Box>
    )
}

export default ChecklistAnswerList
